import { Link } from "react-router-dom";
import { fmtFull } from "@/lib/dates";
import { BellRing, CalendarDays, HeartHandshake, Hourglass, Video } from "lucide-react";

const joinCls = "mt-4 inline-flex items-center gap-2 rounded-full bg-amber-500 hover:bg-amber-400 text-black font-semibold px-5 py-2.5 text-sm transition-colors";

function OneOnOneCard({ s }) {
  return (
    <div data-testid={`dash-1on1-${s.booking_id}`} className="rounded-2xl border border-amber-500/30 bg-amber-500/5 p-6">
      <div className="text-xs uppercase tracking-[0.2em] text-amber-400 font-adult-mono flex items-center gap-2"><Video className="w-3.5 h-3.5" />1-on-1 · {s.reason_label}</div>
      <div className="mt-2 font-adult-heading text-xl">Session with Sankalp</div>
      {s.scheduled_start_iso ? (
        <>
          <div data-testid={`dash-1on1-time-${s.booking_id}`} className="mt-3 text-sm text-zinc-200 flex items-center gap-2"><CalendarDays className="w-4 h-4 text-amber-400" />{fmtFull(s.scheduled_start_iso)}</div>
          {s.call_link
            ? <a href={s.call_link} target="_blank" rel="noreferrer" data-testid={`dash-1on1-join-${s.booking_id}`} className={joinCls}><Video className="w-4 h-4" />Join the call</a>
            : <div className="mt-1 text-xs text-zinc-500">Sankalp&apos;s team will email you the call link.</div>}
          <div className="mt-3 text-xs text-zinc-500 flex items-center gap-1.5"><BellRing className="w-3.5 h-3.5" />You&apos;ll get a reminder email a day before.</div>
        </>
      ) : (
        <>
          <div data-testid={`dash-1on1-pending-${s.booking_id}`} className="mt-3 text-sm text-zinc-200 flex items-center gap-2"><Hourglass className="w-4 h-4 text-amber-400" />Time being confirmed</div>
          {s.preferred_label && <div className="mt-1 text-xs text-zinc-500">Your preference: {s.preferred_label}</div>}
          <div className="mt-1 text-xs text-zinc-500">Sankalp&apos;s team will email you the confirmed time.</div>
        </>
      )}
    </div>
  );
}

function WorkshopCard({ w }) {
  return (
    <div data-testid={`dash-workshop-${w.workshop_id}`} className="rounded-2xl border border-zinc-800 hover:border-amber-500/50 p-6 transition-smooth">
      <div className="text-xs uppercase tracking-[0.2em] text-amber-400 font-adult-mono flex items-center gap-2"><HeartHandshake className="w-3.5 h-3.5" />Live workshop</div>
      <Link to={`/workshops/${w.workshop_id}`} className="mt-2 block font-adult-heading text-xl hover:text-amber-300 transition-colors">{w.title}</Link>
      <div className="mt-3 text-sm text-zinc-300 flex items-center gap-2"><CalendarDays className="w-4 h-4" />{w.start_time_iso ? fmtFull(w.start_time_iso) : "Date announced soon"}</div>
      {w.join_link
        ? <a href={w.join_link} target="_blank" rel="noreferrer" data-testid={`dash-workshop-join-${w.workshop_id}`} className={joinCls}><Video className="w-4 h-4" />Join the workshop</a>
        : <div className="mt-1 text-xs text-zinc-500">The joining link will be emailed before the workshop, with a reminder a day before.</div>}
    </div>
  );
}

export function MentoringTab({ oneOnOnes = [], workshops = [] }) {
  if (!oneOnOnes.length && !workshops.length) {
    return (
      <div data-testid="mentoring-empty" className="rounded-2xl border border-dashed border-zinc-800 p-14 text-center">
        <div className="text-zinc-400">No 1-on-1 sessions or workshops yet.</div>
        <Link to="/meet-sankalp" className="mt-4 inline-block text-amber-400 hover:text-amber-300 text-sm">Meet Sankalp →</Link>
      </div>
    );
  }
  return (
    <div className="grid md:grid-cols-2 gap-4">
      {oneOnOnes.map((s) => <OneOnOneCard key={s.booking_id} s={s} />)}
      {workshops.map((w) => <WorkshopCard key={w.workshop_id} w={w} />)}
    </div>
  );
}
